import { render, staticRenderFns } from "./qualityBrand.vue?vue&type=template&id=0473157a&scoped=true"
import script from "./qualityBrand.vue?vue&type=script&lang=js"
export * from "./qualityBrand.vue?vue&type=script&lang=js"
import style0 from "./qualityBrand.vue?vue&type=style&index=0&id=0473157a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0473157a",
  null
  
)

export default component.exports